export default __webpack_public_path__ + "static/media/circleCloud3.e95842b7.webp";